module.exports = {
  throwError: function throwError(ctx, statusCode, errorCode, message, props) {
    ctx.status = statusCode;
    ctx.body = {
      statusCode: statusCode,
      error: errorCode,
      message: message,
      props: props
    };
  },
  getErrorMsg: function getErrorMsg(err) {
    var withStackTrace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var errMsg = '';
    if (err) {
      if (typeof err === 'string') {
        errMsg = err;
      }
      if (typeof err === 'object') {
        if (err.message) errMsg = err.message;
        if (withStackTrace && err.stack) {
          errMsg = errMsg + '\n' + err.stack;
        }
      }
    }
    return errMsg;
  },
  getAxiosError: function getAxiosError(res) {
    var errObj = {
      statusCode: 0,
      error: '',
      message: ''
    };
    if (res && res.response && res.response.status !== 200) {
      if (res.response.data) {
        errObj = res.response.data;
      } else {
        errObj.statusCode = res.response.status;
        errObj.error = 'ERROR';
        errObj.message = this.stringHasValue(res.message) ? res.message : res.response.statusText;
      }
    }
    return errObj;
  },
  deepCopy: function deepCopy(obj) {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.deepCopy(obj[i]);
      }
      return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = this.deepCopy(obj[attr]);
      }
      return copy;
    }
    throw new Error("Unable to copy obj! Its type isn't supported.");
  },
  getStateAsJSObj: function getStateAsJSObj(state, field) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var stateValue = defaultValue;
    if (state && field && field.length > 0) {
      var fields = typeof field === 'string' ? field.split('.') : field;
      if (fields.length === 1) stateValue = state.get(field); // for single level field
      else stateValue = state.getIn(fields); // for multi level field

      if (stateValue && stateValue.toJS)
        // Check if toJS available before invoke it
        stateValue = stateValue.toJS();
      if (stateValue === undefined || stateValue === null) stateValue = defaultValue;
    }
    return stateValue;
  },
  stringHasValue: function stringHasValue(str) {
    if (!this.isNotNullAndUndefined(str)) {
      return false;
    }
    var strCmp = str;
    if (typeof str !== 'string') strCmp = str.toString();
    return strCmp !== undefined && strCmp !== null && strCmp.trim().length > 0;
  },
  arrayHasItem: function arrayHasItem(arr) {
    return arr && Array.isArray(arr) && arr.length > 0;
  },
  padding: function padding(input, totalChar) {
    var padWith = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
    var padInFront = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var result = input;
    if (totalChar > input.length) {
      for (i = 0; i < totalChar - input.length; i++) {
        if (padInFront) result = padWith + result;else result = result + padWith;
      }
    }
    return result;
  },
  carefullyGetValue: function carefullyGetValue(obj) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var bIsNullorUndefined = obj === null || obj === undefined;
    var curObj = null;
    if (!bIsNullorUndefined) {
      curObj = obj;
      if (props !== null) {
        for (var idx = 0; idx < props.length; idx++) {
          bIsNullorUndefined = curObj[props[idx]] === null || curObj[props[idx]] === undefined;
          curObj = curObj[props[idx]]; // Set the curObj[props[idx]] to curObj so that it will recursive down the depth of the object

          if (bIsNullorUndefined) break;
        }
      }
    }
    if (bIsNullorUndefined) return defaultValue;else return curObj;
  },
  isNotNullAndUndefined: function isNotNullAndUndefined(obj) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var bIsNullorUndefined = obj === null || obj === undefined;
    var curObj = null;
    if (!bIsNullorUndefined) {
      curObj = obj;
      if (props !== null) {
        for (var idx = 0; idx < props.length; idx++) {
          bIsNullorUndefined = curObj[props[idx]] === null || curObj[props[idx]] === undefined;
          curObj = curObj[props[idx]]; // Set the curObj[props[idx]] to curObj so that it will recursive down the depth of the object

          if (bIsNullorUndefined) break;
        }
      }
    }
    return !bIsNullorUndefined;
  },
  textToHtml: function textToHtml(plainText) {
    var includeContainer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var containerTag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'p';
    var htmlText = plainText.replace(/"/g, '&quot;'); // 34 22
    htmlText = htmlText.replace(/&/g, '&amp;'); // 38 26
    htmlText = htmlText.replace(/\'/g, '&#39;'); // 39 27
    htmlText = htmlText.replace(/</g, '&lt;'); // 60 3C
    htmlText = htmlText.replace(/>/g, '&gt;'); // 62 3E
    htmlText = htmlText.replace(/\^/g, '&circ;'); // 94 5E
    htmlText = htmlText.replace(/‘/g, '&lsquo;'); // 145 91
    htmlText = htmlText.replace(/’/g, '&rsquo;'); // 146 92
    htmlText = htmlText.replace(/“/g, '&ldquo;'); // 147 93
    htmlText = htmlText.replace(/”/g, '&rdquo;'); // 148 94
    htmlText = htmlText.replace(/•/g, '&bull;'); // 149 95
    htmlText = htmlText.replace(/–/g, '&ndash;'); // 150 96
    htmlText = htmlText.replace(/—/g, '&mdash;'); // 151 97
    htmlText = htmlText.replace(/˜/g, '&tilde;'); // 152 98
    htmlText = htmlText.replace(/™/g, '&trade;'); // 153 99
    htmlText = htmlText.replace(/š/g, '&scaron;'); // 154 9A
    htmlText = htmlText.replace(/›/g, '&rsaquo;'); // 155 9B
    htmlText = htmlText.replace(/œ/g, '&oelig;'); // 156 9C
    htmlText = htmlText.replace(/ž/g, '&#382;'); // 158 9E
    htmlText = htmlText.replace(/Ÿ/g, '&Yuml;'); // 159 9F
    htmlText = htmlText.replace(/ /g, '&nbsp;'); // 160 A0
    htmlText = htmlText.replace(/¡/g, '&iexcl;'); // 161 A1
    htmlText = htmlText.replace(/¢/g, '&cent;'); // 162 A2
    htmlText = htmlText.replace(/£/g, '&pound;'); // 163 A3
    htmlText = htmlText.replace(/¥/g, '&yen;'); // 165 A5
    htmlText = htmlText.replace(/¦/g, '&brvbar;'); // 166 A6
    htmlText = htmlText.replace(/§/g, '&sect;'); // 167 A7
    htmlText = htmlText.replace(/¨/g, '&uml;'); // 168 A8
    htmlText = htmlText.replace(/©/g, '&copy;'); // 169 A9
    htmlText = htmlText.replace(/ª/g, '&ordf;'); // 170 AA
    htmlText = htmlText.replace(/«/g, '&laquo;'); // 171 AB
    htmlText = htmlText.replace(/¬/g, '&not;'); // 172 AC
    htmlText = htmlText.replace(/­/g, '&shy;'); // 173 AD
    htmlText = htmlText.replace(/®/g, '&reg;'); // 174 AE
    htmlText = htmlText.replace(/¯/g, '&macr;'); // 175 AF
    htmlText = htmlText.replace(/°/g, '&deg;'); // 176 B0
    htmlText = htmlText.replace(/±/g, '&plusmn;'); // 177 B1
    htmlText = htmlText.replace(/²/g, '&sup2;'); // 178 B2
    htmlText = htmlText.replace(/³/g, '&sup3;'); // 179 B3
    htmlText = htmlText.replace(/´/g, '&acute;'); // 180 B4
    htmlText = htmlText.replace(/µ/g, '&micro;'); // 181 B5
    htmlText = htmlText.replace(/¶/g, '&para'); // 182 B6
    htmlText = htmlText.replace(/·/g, '&middot;'); // 183 B7
    htmlText = htmlText.replace(/¸/g, '&cedil;'); // 184 B8
    htmlText = htmlText.replace(/¹/g, '&sup1;'); // 185 B9
    htmlText = htmlText.replace(/º/g, '&ordm;'); // 186 BA
    htmlText = htmlText.replace(/»/g, '&raquo;'); // 187 BB
    htmlText = htmlText.replace(/¼/g, '&frac14;'); // 188 BC
    htmlText = htmlText.replace(/½/g, '&frac12;'); // 189 BD
    htmlText = htmlText.replace(/¾/g, '&frac34;'); // 190 BE
    htmlText = htmlText.replace(/¿/g, '&iquest;'); // 191 BF
    htmlText = htmlText.replace(/À/g, '&Agrave;'); // 192 C0
    htmlText = htmlText.replace(/Á/g, '&Aacute;'); // 193 C1
    htmlText = htmlText.replace(/Â/g, '&Acirc;'); // 194 C2
    htmlText = htmlText.replace(/Ã/g, '&Atilde;'); // 195 C3
    htmlText = htmlText.replace(/Ä/g, '&Auml;'); // 196 C4
    htmlText = htmlText.replace(/Å/g, '&Aring;'); // 197 C5
    htmlText = htmlText.replace(/Æ/g, '&AElig;'); // 198 C6
    htmlText = htmlText.replace(/Ç/g, '&Ccedil;'); // 199 C7
    htmlText = htmlText.replace(/È/g, '&Egrave;'); // 200 C8
    htmlText = htmlText.replace(/É/g, '&Eacute;'); // 201 C9
    htmlText = htmlText.replace(/Ê/g, '&Ecirc;'); // 202 CA
    htmlText = htmlText.replace(/Ë/g, '&Euml;'); // 203 CB
    htmlText = htmlText.replace(/Ì/g, '&Igrave;'); // 204 CC
    htmlText = htmlText.replace(/Í/g, '&Iacute;'); // 205 CD
    htmlText = htmlText.replace(/Î/g, '&Icirc;'); // 206 CE
    htmlText = htmlText.replace(/Ï/g, '&Iuml;'); // 207 CF
    htmlText = htmlText.replace(/Ð/g, '&ETH;'); // 208 D0
    htmlText = htmlText.replace(/Ñ/g, '&Ntilde;'); // 209 D1
    htmlText = htmlText.replace(/Ò/g, '&Ograve;'); // 210 D2
    htmlText = htmlText.replace(/Ó/g, '&Oacute;'); // 211 D3
    htmlText = htmlText.replace(/Ô/g, '&Ocirc;'); // 212 D4
    htmlText = htmlText.replace(/Õ/g, '&Otilde;'); // 213 D5
    htmlText = htmlText.replace(/Ö/g, '&Ouml;'); // 214 D6
    htmlText = htmlText.replace(/×/g, '&times;'); // 215 D7
    htmlText = htmlText.replace(/Ø/g, '&Oslash;'); // 216 D8
    htmlText = htmlText.replace(/Ù/g, '&Ugrave;'); // 217 D9
    htmlText = htmlText.replace(/Ú/g, '&Uacute;'); // 218 DA
    htmlText = htmlText.replace(/Û/g, '&Ucirc;'); // 219 DB
    htmlText = htmlText.replace(/Ü/g, '&Uuml;'); // 220 DC
    htmlText = htmlText.replace(/Ý/g, '&Yacute;'); // 221 DD
    htmlText = htmlText.replace(/Þ/g, '&THORN;'); // 222 DE
    htmlText = htmlText.replace(/ß/g, '&szlig;'); // 223 DF
    htmlText = htmlText.replace(/à/g, '&aacute;'); // 224 E0
    htmlText = htmlText.replace(/á/g, '&aacute;'); // 225 E1
    htmlText = htmlText.replace(/â/g, '&acirc;'); // 226 E2
    htmlText = htmlText.replace(/ã/g, '&atilde;'); // 227 E3
    htmlText = htmlText.replace(/ä/g, '&auml;'); // 228 E4
    htmlText = htmlText.replace(/å/g, '&aring;'); // 229 E5
    htmlText = htmlText.replace(/æ/g, '&aelig;'); // 230 E6
    htmlText = htmlText.replace(/ç/g, '&ccedil;'); // 231 E7
    htmlText = htmlText.replace(/è/g, '&egrave;'); // 232 E8
    htmlText = htmlText.replace(/é/g, '&eacute;'); // 233 E9
    htmlText = htmlText.replace(/ê/g, '&ecirc;'); // 234 EA
    htmlText = htmlText.replace(/ë/g, '&euml;'); // 235 EB
    htmlText = htmlText.replace(/ì/g, '&igrave;'); // 236 EC
    htmlText = htmlText.replace(/í/g, '&iacute;'); // 237 ED
    htmlText = htmlText.replace(/î/g, '&icirc;'); // 238 EE
    htmlText = htmlText.replace(/ï/g, '&iuml;'); // 239 EF
    htmlText = htmlText.replace(/ð/g, '&eth;'); // 240 F0
    htmlText = htmlText.replace(/ñ/g, '&ntilde;'); // 241 F1
    htmlText = htmlText.replace(/ò/g, '&ograve;'); // 242 F2
    htmlText = htmlText.replace(/ó/g, '&oacute;'); // 243 F3
    htmlText = htmlText.replace(/ô/g, '&ocirc;'); // 244 F4
    htmlText = htmlText.replace(/õ/g, '&otilde;'); // 245 F5
    htmlText = htmlText.replace(/ö/g, '&ouml;'); // 246 F6
    htmlText = htmlText.replace(/÷/g, '&divide;'); // 247 F7
    htmlText = htmlText.replace(/ø/g, '&oslash;'); // 248 F8
    htmlText = htmlText.replace(/ù/g, '&ugrave;'); // 249 F9
    htmlText = htmlText.replace(/ú/g, '&uacute;'); // 250 FA
    htmlText = htmlText.replace(/û/g, '&ucirc;'); // 251 FB
    htmlText = htmlText.replace(/ü/g, '&uuml;'); // 252 FC
    htmlText = htmlText.replace(/ý/g, '&yacute;'); // 253 FD
    htmlText = htmlText.replace(/þ/g, '&thorn;'); // 254 FE
    htmlText = htmlText.replace(/ÿ/g, '&yuml;'); // 255 FF
    htmlText = htmlText.replace(/\n/g, '<br/>');
    return includeContainer ? "<".concat(containerTag, ">").concat(htmlText, "</").concat(containerTag, ">") : htmlText;
  },
  convertTZ: function convertTZ(date) {
    var tzString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Asia/Singapore';
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {
      timeZone: tzString
    }));
  }
};